export interface CourierAdvantage {
  icon: string;
  title: string;
  desc: string;
}

export interface CourierFaq {
  q: string;
  a: string;
}

export interface CourierCase {
  name: string;
  role: string;
  avatar: string;
  content: string;
}

export interface TrackStep {
  time: string;
  title: string;
  desc: string;
  done: boolean;
}

export const courierAdvantages: CourierAdvantage[] = [
  {
    icon: "ri-flashlight-fill",
    title: "同城最快 30 分钟送达",
    desc: "智能调度系统就近派单，骑手全程冷链保温箱，热食到手依旧温热。",
  },
  {
    icon: "ri-map-pin-2-line",
    title: "全城覆盖 120+ 配送片区",
    desc: "主城区与近郊全面覆盖，写字楼、住宅区、校园均设有专属取送网点。",
  },
  {
    icon: "ri-shield-check-line",
    title: "全程保价 丢损必赔",
    desc: "每一单自动投保，生鲜、药品、文件等特殊品类可升级冷链与加急保障。",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "7×24 小时专属客服",
    desc: "下单后可实时联系配送专员，异常订单 5 分钟内响应处理。",
  },
];

export const courierFaqs: CourierFaq[] = [
  {
    q: "寄件需要提前预约吗？",
    a: "当天寄件建议提前 1 小时下单，高峰期（11:00-13:00、17:00-19:00）建议提前 2 小时，我们会根据取件地址自动匹配最近的骑手。",
  },
  {
    q: "包裹可以保价吗？",
    a: "可以。基础保价额度为 500 元以内，贵重物品可在下单时选择升级保价，最高可保 5 万元，丢损按保价金额赔付。",
  },
  {
    q: "生鲜和药品能寄吗？",
    a: "可以寄送。生鲜类订单将使用冷链保温箱配送，药品类可选择加急专送，请在下单时备注品类，我们会安排专属骑手。",
  },
  {
    q: "快递单号在哪里查询？",
    a: "下单成功后系统会生成专属运单号，您可以在「快递查询」页面输入单号，实时查看从揽收、运输到签收的完整轨迹。",
  },
  {
    q: "配送失败会怎么处理？",
    a: "若因收件人未接听导致配送失败，骑手会在原地等待 10 分钟并二次联系；仍无法送达的订单将退回取件点，并在 24 小时内联系您重新派送。",
  },
];

export const courierCases: CourierCase[] = [
  {
    name: "林晓雯",
    role: "互联网公司 · 行政",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20headshot%20of%20a%20friendly%20young%20chinese%20office%20lady%20smiling%2C%20clean%20warm%20neutral%20background%2C%20soft%20studio%20lighting%2C%20professional%20but%20natural%2C%20high%20detail&width=200&height=200&seq=courier-user-01&orientation=squarish",
    content:
      "公司团建定的 40 份餐点，用美味的快递一次全部送到，还提前 10 分钟到，摆放得整整齐齐，同事都在问是哪家。",
  },
  {
    name: "陈立",
    role: "自由摄影师",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20headshot%20of%20a%20chinese%20young%20man%20with%20glasses%20smiling%2C%20clean%20warm%20neutral%20background%2C%20soft%20studio%20lighting%2C%20natural%20and%20friendly%2C%20high%20detail&width=200&height=200&seq=courier-user-02&orientation=squarish",
    content:
      "有次急着把合同送去客户那边，下单 20 分钟骑手就到了，全程还能看到定位，交到客户手里那一刻特别安心。",
  },
  {
    name: "苏梦",
    role: "全职妈妈",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20headshot%20of%20a%20warm%20chinese%20mother%20smiling%20gently%2C%20clean%20warm%20neutral%20background%2C%20soft%20studio%20lighting%2C%20natural%20and%20kind%2C%20high%20detail&width=200&height=200&seq=courier-user-03&orientation=squarish",
    content:
      "给孩子熬的汤忘了带，用同城寄送半小时就送到了学校，保温做得特别好，还是热的，真的太方便了。",
  },
];

export const sampleTracking: TrackStep[] = [
  { time: "今天 10:12", title: "已签收", desc: "包裹已由收件人本人签收，感谢使用美味的快递", done: true },
  { time: "今天 09:48", title: "派送中", desc: "骑手张小哥正在为您派送，预计 15 分钟内送达", done: true },
  { time: "今天 09:05", title: "到达目的地网点", desc: "包裹已到达朝阳区望京配送站，正在分拣", done: true },
  { time: "今天 08:10", title: "运输中", desc: "包裹已从海淀中转中心发出，前往望京配送站", done: true },
  { time: "今天 07:32", title: "已揽收", desc: "骑手李师傅已揽收，送往海淀中转中心", done: true },
  { time: "今天 07:05", title: "已下单", desc: "订单已创建成功，正在为您匹配骑手", done: true },
];